/**
 * Supabase client initialization.
 *
 * Creates and exports a typed Supabase client instance using the
 * centralized config values. All modules should import `supabase`
 * from here rather than creating their own client.
 */

import { config } from '@/config'
import { createClient } from '@supabase/supabase-js'

export const supabase = createClient(
    config.supabaseUrl,
    config.supabaseAnonKey,
    {
        db: {
            // PostgREST only exposes the 'api' schema. All RPC functions
            // (get_my_role, set_my_role, admin_*, get_admin_users) live there.
            // Auth calls (supabase.auth.*) are unaffected — they use GoTrue.
            schema: 'api',
        },
        auth: {
            // CRITICAL: Disable PKCE flow for manual OTP verification.
            // With PKCE (the default in SDK v2.39+), signInWithOtp generates a
            // code_verifier that must accompany verifyOtp. If the verifier is lost
            // (e.g. page reload, HMR) or mishandled, ALL verify attempts fail
            // with "otp_expired" regardless of token type.
            // Since we use a 6-digit PIN entry (not redirect-based magic links),
            // the implicit flow is the correct choice.
            flowType: 'implicit'
        }
    }
)
